import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/services';
import { 
  Container,
  Recycle,
  ShieldCheck,
  Mountain,
  Droplets,
  Factory,
  ArrowRight
} from 'lucide-react';
import { Button } from './ui/button';

const iconMap = {
  Container,
  Recycle,
  ShieldCheck,
  Mountain,
  Droplets,
  Factory
};

const ServicesShowcase = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold tracking-wider uppercase text-sm">Our Expertise</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#1a365d] mt-4 mb-6">
            Full-Service Environmental <span className="text-blue-500">Solutions</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Beyond bin rentals, we offer a comprehensive suite of environmental and waste management 
            services to meet all your project needs under one roof.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Link
                key={service.id}
                to={`/services/${service.slug}`}
                className="group relative bg-gray-50 rounded-2xl p-8 hover:bg-[#1a365d] transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-[#1a365d] group-hover:bg-white/20 rounded-xl flex items-center justify-center mb-6 transition-colors">
                  <Icon className="h-7 w-7 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-[#1a365d] group-hover:text-white mb-3 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 group-hover:text-white/80 mb-4 transition-colors">
                  {service.shortDescription}
                </p>

                {/* Highlights */}
                <ul className="space-y-2 mb-6">
                  {service.highlights.slice(0, 2).map((h, idx) => (
                    <li key={idx} className="text-sm text-gray-500 group-hover:text-white/70 flex items-center space-x-2 transition-colors">
                      <div className="w-1.5 h-1.5 bg-blue-500 group-hover:bg-blue-300 rounded-full"></div>
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>

                {/* Link */}
                <span className="flex items-center text-blue-600 group-hover:text-blue-300 font-medium text-sm transition-colors">
                  Learn more
                  <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link to="/services">
            <Button className="bg-[#1a365d] hover:bg-[#2d4a7c] text-white font-semibold px-8 py-4 text-lg rounded-lg transition-all duration-300 hover:scale-105">
              View All Services
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesShowcase;
